import { Component, EventEmitter, Inject, Injector, Input, OnInit, Output, ViewChild } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators, FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { plainToClass } from 'class-transformer'
import { UpdateUserRequest } from '@dto/updateUserRequest'
import { UsersService } from '@services/entity/users.service'
import '@angular/localize/init'
import { RfidCardDto } from '../../../../dto/rfidCardDto'
import { UserEditDto } from '@dto/userEditDto'
import { ComponentBase } from '@abstracts/component-base'
import { FormService } from '@services/form/form.service'
import { RouteDataService } from '@services/route-data/route-data.service'
import { ChargingStationsService } from '@services/entity/charging-stations.service'
import { isEqual } from 'lodash-es'
import { ChargingStationByGroupDto } from '@dto/chargingStationByGroupDto'
import { NgSelectComponent } from '@ng-select/ng-select'
import { ToastService } from '@services/toast/toast.service'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { RfidCardsService } from '@services/entity/rfidCards.service'
import { ChargingstationGroupDto } from '@dto/chragingstationGroupDto'
import { SendInviteRequest } from '@dto/sendInviteRequest'
import { ChargingPowerProfilesService } from '@services/entity/chargingPowerProfiles.service'
import { ChargingPowerProfile } from '@models/chargingPowerProfile'
import { BlackboxService } from '@services/entity/blackbox.service'

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  providers: []
})
export class EditUserComponent extends ComponentBase implements OnInit {

  spinner1 = 'editSpinner';

  public className = 'EditUserComponent'

  private primaryKey: string

  public entity: UserEditDto
  public rfidCards: RfidCardDto[]
  public rfidCardsFiltered: RfidCardDto[]
  public chargingStations: ChargingStationByGroupDto[]
  public filteredChargingStations: ChargingStationByGroupDto[]
  public chargingGroups: ChargingstationGroupDto[]
  public chargingPowerProfiles: ChargingPowerProfile[] = []
  public chargingPowerProfile: ChargingPowerProfile

  public formReady: boolean
  public chargingStationEdited: boolean = false
  public rfidEdited: boolean = false
  public chargingPowerProfileEdited: boolean = false
  public isAddingNewEmail: boolean = false
  public iAmFalse: boolean = false
  public iAmTrue: boolean = true
  public isBtnSaveDisabled: boolean = false;
  public isSupporter: boolean = false;

  @Input() customerId: number

  @Output() entityLoadedEvent = new EventEmitter<UserEditDto>()

  @ViewChild('chargingStationSelect') chargingStationSelect: NgSelectComponent

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public activeModal: NgbActiveModal,
    private usersService: UsersService,
    private rfidCardsService: RfidCardsService,
    private chargingStationsService: ChargingStationsService,
    private chargingPowerProfilesService: ChargingPowerProfilesService,
    private formService: FormService,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private toastService: ToastService,
    private blackboxesService: BlackboxService,
    public injector: Injector
  ) {
    super(injector)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.primaryKey = this.activatedRoute.snapshot.params.key
    if (!this.primaryKey) {
      this.primaryKey = this.routeDataService.params.key
    }
    this.isSupporter = this.authenticationService.userHasRole('Supporter');
    this.loadEntity()
  }

  loadEntity() {
    this.usersService.getUserEditDto(this.primaryKey).subscribe(result => {
      if (result) {
        this.entity = plainToClass(UserEditDto, result)

        if (!this.entity.chargingPowerProfileId) {
          this.entity.chargingPowerProfileId = 1
        }

        this.loadRfidCards()
        this.loadChargingGroups()
        this.loadChargingStations()
        this.getChargingPowerProfiles()
        this.createForm()
      }
    }, error => {
      console.error(error)
    })
  }

  loadRfidCards() {
    if (this.customerId) {
      this.rfidCardsService.getRfidCardsOfCustomer(this.customerId).subscribe(rfidCards => {
        if (rfidCards) {
          this.rfidCards = plainToClass(RfidCardDto, rfidCards)
          this.filterRfidCards()
        }
      }, error => { })
    } else {
      this.rfidCardsService.getRfidCardsOfCurrentCustomer().subscribe(rfidCards => {
        if (rfidCards) {
          this.rfidCards = plainToClass(RfidCardDto, rfidCards)
          this.filterRfidCards()
        }
      }, error => { })
    }
  }

  loadChargingGroups() {
    if (this.customerId) {
      this.chargingStationsService.getChargingstationGroupsOfCustomer(this.customerId).subscribe(result => {
        this.chargingGroups = result
      }, error => { });
    } else {
      this.chargingStationsService.getChargingstationGroups().subscribe(result => {
        this.chargingGroups = result
      }, error => { });
    }
  }

  loadChargingStations() {
    if (this.customerId) {
      this.chargingStationsService.getChargingstationsOfCustomerByGroup(this.customerId).subscribe(result => {
        if (result) {
          this.chargingStations = plainToClass(ChargingStationByGroupDto, result)
          this.filterChargingStations()
        }
      }, error => { })
    } else {
      this.chargingStationsService.getChargingstationsByGroup().subscribe(result => {
        this.chargingStations = plainToClass(ChargingStationByGroupDto, result)
        this.filterChargingStations()
      }, error => { })
    }
  }

  getChargingPowerProfiles() {
    if (!this.entity.selectedCustomerId) return;
    this.blackboxesService.getByCustomerId(this.entity.selectedCustomerId).subscribe(result => {
      if (result.length == 0 || result == null) return;

      this.chargingPowerProfilesService.getAll().subscribe(result => {
        this.chargingPowerProfiles = result
        this.formService.form.get('chargingPowerProfile').setValue(
          this.chargingPowerProfiles.find(cpp => cpp.id == this.entity.chargingPowerProfileId)
        )
      }, error => {
        this.toastService.error(`Ladeprofile konnten nicht geladen werden.`)
      });
    })
  }

  createForm() {
    this.formService.validators = {
      email: [Validators.email, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)],
      firstName: [Validators.maxLength(50), Validators.required],
      lastName: [Validators.maxLength(50), Validators.required]
    }

    this.formService.form = new UntypedFormGroup({
      email: new UntypedFormControl(this.entity.email, this.formService.validators['email']),
      firstName: new UntypedFormControl(this.entity.firstName, this.formService.validators['firstName']),
      lastName: new UntypedFormControl(this.entity.lastName, this.formService.validators['lastName']),
      rfidCards: new UntypedFormControl(this.entity.rfidCards),
      pricingId: new UntypedFormControl({value: this.entity.pricingName, disabled: true}),
      chargingStations: new UntypedFormControl(this.entity.chargingStations),
      chargingGroups: new UntypedFormControl(this.entity.chargingGroups),
      newEmail: new UntypedFormControl("", this.formService.validators['email']),
      chargingPowerProfile: new FormControl(this.entity.chargingPowerProfileId)
    })

    this.entityLoadedEvent.emit(this.entity)

    if (this.entity.username == this.entity.id) {
      this.formService.form.addControl('email', new UntypedFormControl(this.entity.email));
    } else {
      this.formService.form.addControl('email', new UntypedFormControl(this.entity.email, this.formService.validators['email']));
    }

    this.formReady = true
    this.formService.valuesAtInit = this.formService.form.getRawValue()

    this.formService.form.valueChanges.subscribe(entity => {
      if (entity && isEqual(entity, this.formService.valuesAtInit)) {
        this.formService.unsavedChanges = false
      } else {
        this.formService.unsavedChanges = true
      }
    })

    this.formService.form.get('pricingId').disable()
    if (this.isSupporter) this.formService.form.disable()
  }

  onSubmit(formValue) {
    this.isBtnSaveDisabled = true;

    if (this.isAddingNewEmail && (formValue.newEmail == null || formValue.newEmail.length == 0)) {
      this.toastService.error('Email Adresse wird benötigt!')
      return
    }
    this.toastService.loading($localize`:@@SavingSettingsToast:Einstellungen werden gespeichert.`)

    var updateUserRequest: UpdateUserRequest = {
      id: this.primaryKey,
      clientURI: this.baseUrl + 'auth/emailChangeConfirm',
      rfidCards: formValue.rfidCards,
      chargingStations: formValue.chargingStations,
      chargingGroups: formValue.chargingGroups,
      areChargingStationsEdited: this.chargingStationEdited,
      areRfidsEdited: this.rfidEdited,
      chargingPowerProfileEdited: this.chargingPowerProfileEdited,
      newEmail: formValue.newEmail,
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      chargingPowerProfileId: formValue.chargingPowerProfile.id
    }

    this.usersService.updateUser(updateUserRequest.id, updateUserRequest).subscribe(result => {
      if (result) {
        this.toastService.success($localize`:@@SavingSettingsSuccessToast:Einstellungen erfolgreich gespeichert.`, 0, true)
        if (this.isAddingNewEmail) {
          const sendInviteRequest = this.mapUpdateUserRequestToSendInviteRequest(updateUserRequest);
          this.sendInviteEmail(sendInviteRequest);
        }
        this.activeModal.close();
      }
      else {
        this.isBtnSaveDisabled = false;
        this.toastService.error($localize`:@@SavingSettingsErrorToast:Einstellungen konnten nicht gespeichert werden.`, 0, true)
      }
    }, error => {
      this.isBtnSaveDisabled = false;
      this.toastService.error($localize`:@@SavingSettingsErrorToast:Einstellungen konnten nicht gespeichert werden.`, 0, true)
    })
  }

  rfidChanged() {
    this.rfidEdited = true;
  }

  chargingStationChanged() {
    this.chargingStationEdited = true;
  }

  chargingGroupChanged() {
    this.chargingStationEdited = true;
    this.filterChargingStations();
  }

  chargingPowerProfileChanged() {
    this.chargingPowerProfileEdited = true;
  }

  onIsAddingNewEmailChange() {
    this.isAddingNewEmail = !this.isAddingNewEmail
  }

  mapUpdateUserRequestToSendInviteRequest(updateUserRequest: UpdateUserRequest): SendInviteRequest {
    const sendInviteRequest: SendInviteRequest = {
      email: updateUserRequest.newEmail,
      firstName: updateUserRequest.firstName,
      lastName: updateUserRequest.lastName,
      clientURI: this.baseUrl + 'auth/register',
      invitingCustomerId: this.entity.selectedCustomerId
    }

    return sendInviteRequest;
  }

  sendInviteEmail(sendInviteRequest: SendInviteRequest) {
    this.authenticationService.sendInvite(sendInviteRequest).subscribe(result => {
      this.toastService.success($localize`:@@EditUserDialogInviteSuccessHeader:Benutzer wurde eingeladen.`);
    }, error => { });
  }

  filterChargingStations() {
    this.filteredChargingStations = this.chargingStations.filter(cs =>
      !this.formService.form.get('chargingGroups').value.some(cg =>
        cs.allGroupsId.includes(cg.id)))
    this.filteredChargingStations.sort((a, b) => a.name > b.name ? 1 : -1);

    this.formService.form.get('chargingStations').setValue(this.formService.form.get('chargingStations').value.filter(cs =>
      !this.formService.form.get('chargingGroups').value.some(cg =>
        cs.allGroupsId.includes(cg.id))))
  }

  filterRfidCards() {
    this.rfidCardsFiltered = this.rfidCards.filter(rfid => (rfid.idTag != 'freecharge' && (rfid.userId == null || rfid.userId == this.entity.id)))
  }
}
